export const getEnv = () => {
    let env;

    if (process.env.NODE_ENV === 'production') {
        if (
            window.location.port === '5000' ||
            window.location.host === "www.gruposantillana.com.br" ||
            window.location.host === "www.santillana.com.br"
        ) {
            env = 'prd';
        } else if (window.location.host === "pre.santillana.com.br") {
            // Hml
            env = 'hml';
        } else if (window.location.host === "dev.santillana.com.br") {
            // Dev
            env = 'dev';
        } else {
            env = 'dev';
        }
    } else {
        env = 'dev';
    }

    return env;
}